(function () {
    fabric.Palette = fabric.util.createClass(
        /** @lends fabric.Palette.prototype */ {
            type: 'letter',
            /**
             * Constructor
             * @param {Object} options Options object with type
             * @return {fabric.Palette} thisArg
             */
            initialize: function (options) {
                options || (options = {});

                // eslint-disable-next-line @typescript-eslint/no-this-alias
                let _this = this;

                Object.keys(options).forEach(function (option) {
                    _this[option] = options[option];
                });

                if (this.id) {
                    this.id += '_' + fabric.Object.__uid++;
                } else {
                    this.id = fabric.Object.__uid++;
                }

                this.colors = options.colors || [];
            },

            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            toObject: function (propertiesToInclude) {
                //
            },

            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            toLive: function (_ctx, _object) {
                if (!this.type) {
                    return;
                }
            },

            getColor: function (index) {
                const newIndex = index % this.colors.length;
                return this.colors[newIndex].hex || '#000000';
            }
        }
    );
})();
